/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { resourceDetailResponseSchema } from './resourceDetailResponseSchema';

export const pageResponseResourceDetailResponseSchema = z.object({
  cursor: z.string().nullish(),
  get data() {
    return z.array(resourceDetailResponseSchema);
  },
  hasNextPage: z.boolean().nullish(),
  recordCount: z.int().nullish(),
  recordLimit: z.int().nullish(),
});
